import * as Api from '@ViewModels';

export const ALL_IMAGE_SOURCES = 'all';

/** Shared by the picker tab and the library manager so a new source only has to be added once. */
export const IMAGE_SOURCE_FILTERS = [
	{ value: ALL_IMAGE_SOURCES, label: 'All' },
	{ value: Api.ImageLibrarySource.Upload, label: 'Uploaded' },
	{ value: Api.ImageLibrarySource.Stock, label: 'Stock' },
	{ value: Api.ImageLibrarySource.AIGenerated, label: 'AI' },
];

export function toImageSourceFilter(value: string) {
	return value === ALL_IMAGE_SOURCES ? undefined : (value as Api.ImageLibrarySource);
}
